import Link from '@components/ui/Link'
import OrderItemImage from '../shared/OrderItemImage'
import styles from './styles.module.scss'

const CONFIG = {
  error: {
    message: 'Oops! something failed. Please try again later',
    linkText: undefined,
    linkUrl: undefined
  },
  noOrders: {
    message: 'You currently have no orders.',
    linkText: 'Continue Shopping',
    linkUrl: '/collections/best-sellers'
  }
}

export function NoOrderItem({
  variant = 'noOrders'
}: {
  variant?: 'error' | 'noOrders'
}) {
  const { message, linkText, linkUrl } = CONFIG[variant]
  return (
    <div className={styles.NoOrderItem}>
      <div className={styles.NoOrderItem__header}>
        <span>{message}</span>
        {linkUrl && linkText && (
          <div className={styles.NoOrderItem__headerLink}>
            <Link href={linkUrl} text={linkText} />
          </div>
        )}
      </div>
      <div className={styles.NoOrderItem__content}>
        {linkUrl && linkText && (
          <div className={styles.NoOrderItem__headerLink}>
            <Link href={linkUrl} text={linkText} />
          </div>
        )}

        <OrderItemImage image="/static/images/account/no-orders-image.jpg" />
      </div>
    </div>
  )
}
